module.exports = __webpack_public_path__ + "img/furbolg_shaman_small.3014b9fc.png";